import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { ROLE_PERMISSIONS } from "../constants/permissions";
import useIsAuthenticated from "../hooks/useIsAuthenticated";
import useUser from "../hooks/useUser";

export default function PermissionRoute({ module, children }) {
  const location = useLocation();

  useIsAuthenticated(location.pathname);

  useUser();

  const auth = useAuth();
  const role = auth.user?.role;

  if (!auth.user) return <Navigate to="/login" />;

  const allowed = ROLE_PERMISSIONS[role]?.includes(module);

  return allowed ? children : <Navigate to="/" replace />;

}